import React, { Component } from "react";

import { Radio } from "antd";

import { Redirect, withRouter } from "react-router-dom";

import Player from "../../containers/Player";
import Core from "../../Core";

import "./index.scss";

class PlayerPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
    };
    this.verifyLogin = this.verifyLogin.bind(this);
  }

  componentDidMount() {
    this.verifyLogin();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  verifyLogin() {
    if (!Core.data().login) {
      this.setState({ redirect: true });
    }
  }

  render() {
    const { redirect } = this.state;
    if (redirect) {
      if (Core.data().config.login == true) {
        return <Redirect to="/login" />;
      }
      return <Redirect to="/" />;
    }
    return (
      <div className="page default-bg">
        <div className="page__wrapper">
          <div span={24} className="page__nav">
            <Radio.Group
              options={[
                {
                  label: "Program",
                  value: "program",
                },
                {
                  label: "Event",
                  value: "player",
                },
              ]}
              onChange={(val) =>
                this.props.history.push(`/${val.target.value}`)
              }
              value={"player"}
              optionType="button"
              buttonStyle="solid"
            />
          </div>
          <div className="page__player">
            <Player />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PlayerPage);